import {injectable, inject} from "tsyringe";
import type { EditorSettings } from "$src/domain/designs/settings/EditorSettings";
import type { IEditorSettingsRepository } from "$src/domain/designs/settings/IEditorSettingsRepository";


@injectable()
export class EditorSettingsService {

    private editorSettingsRepository: IEditorSettingsRepository;

    constructor(@inject("IEditorSettingsRepository") editorSettingsRepository: IEditorSettingsRepository) {
        this.editorSettingsRepository = editorSettingsRepository;
    }

    async getByUsernameAsync(username: string): Promise<EditorSettings> {

        return await this.editorSettingsRepository.getByUsernameAsync(username);
    }

    async createOrUpdateAsync(settings: EditorSettings): Promise<void> {
        await this.editorSettingsRepository.createOrUpdateAsync(settings);
    }
}
